import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export enum RoutesIds {
  surfaces = 'surfaces',
  surface = 'surface',
  surfaceSettings = 'surfaceSettings',
  surfaceAvailability = 'surfaceAvailability',
}

enum ExternalRoutesIds {
  experimentationPlatformSurface = 'experimentationPlatformSurface',
}

// root route
export const surfacesRouteRef = createPageRoute({
  id: 'surface-index',
  page: { title: 'Surfaces' },
});

export const rootRouteRef = surfacesRouteRef;

// sub-routes within the plugin
export const surfaceRouteRef = createPageRoute({
  id: RoutesIds.surface,
  route: { parent: rootRouteRef, path: '/:id' },
  page: { title: 'Surface' },
});

export const surfaceSettingsRouteRef = createSubRouteRef({
  id: RoutesIds.surfaceSettings,
  parent: rootRouteRef,
  path: '/:id/settings',
});

export const surfaceAvailabilityRouteRef = createSubRouteRef({
  id: RoutesIds.surfaceAvailability,
  parent: rootRouteRef,
  path: '/:id/availability',
});

// external routes to other systems (for backward compatibility during migration)
export const experimentationPlatformSurfaceRouteRef = createExternalRouteRef({
  id: 'backstage-experimentation-platform-surface',
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  surfaces: surfacesRouteRef,
  surface: surfaceRouteRef,
  surfaceSettings: surfaceSettingsRouteRef,
  surfaceAvailability: surfaceAvailabilityRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other systems
  experimentationPlatformSurface: experimentationPlatformSurfaceRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
